<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-Cancun-3.webp',
                    '/pagesImages/instalaciones-Cancun-5.webp',
                    '/pagesImages/instalaciones-Cancun-6.webp',
                    '/pagesImages/instalaciones-Cancun-7.webp',
                    '/pagesImages/instalaciones-Cancun-8.webp',
                    '/pagesImages/instalaciones-Cancun-12.webp',
                    '/pagesImages/instalaciones-Cancun-13.webp',
                    '/pagesImages/biblioteca-Cancun-2.webp',
                    '/pagesImages/gesell-Cancun-1.webp',
                    '/pagesImages/cafeteria-Cancun-2.webp',
                ],
                images2: [
                    '/pagesImages/instalaciones-Cancun-11.webp',
                    '/pagesImages/areas verdes-Cancun-1.webp',
                    '/pagesImages/areas-verdes-Cancun-2.webp',
                    '/pagesImages/cancha-Cancun-1.webp',
                    '/pagesImages/auditorio-Cancun-1.webp',
                    '/pagesImages/instalaciones-Cancun-4.webp',
                    '/pagesImages/auditorio-Cancun-2.webp',
                    '/pagesImages/escultura-leon-Cancun-3.webp',
                    '/pagesImages/cafeteria-Cancun-1.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Cancun-2.webp",
                    "/pagesImages/encabezado-landing-Cancun-3.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Cancún",
                    "Fotos de campus Magno Cancún",
                ],
                tour: [
                    { src:"/pagesImages/tour-Cancun-1.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-2.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-3.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-4.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-5.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-6.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-7.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-8.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-9.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-10.webp", title:"Tour virtual de Campus Magno Cancún"},
                    { src:"/pagesImages/tour-Cancun-11.webp", title:"Tour virtual de Campus Magno Cancún"},
                ],
                campusName: "CANCÚN",
                campusType: "CAMPUS MAGNO",
                localidad: "Quintana Roo",
                frase: "La educación es el arma más poderosa que puedes usar para cambiar el mundo",
                autor: "Nelson Mandela",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Magno Cancún'" :testo1="'Es un espacio educativo diseñado para inspirar, conectar y transformar. Su arquitectura fusiona el estilo clásico y la funcionalidad moderna, generando una atmósfera que estimula el aprendizaje, la reflexión y el desarrollo personal.'" :testo2="'Estudiar en Campus Magno Cancún significa formar parte de una comunidad académica de alto nivel.'" :testo3="'Los espacios interiores se funden con la vitalidad de hermosos jardines y áreas verdes, donde la riqueza selvática de Cancún forman parte de la experiencia educativa de alto nivel.'" :img="'/pagesImages/instalaciones-Cancun.webp'" :alt="'Campus Magno Cancún'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Los espacios han sido concebidos para brindar una experiencia académica de primer nivel. Aquí, el conocimiento se<br class="lg:block hidden"> gesta en un ambiente que promueve los valores, la ética y el desarrollo integral.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Instalaciones especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Áreas equipadas para disciplinas como Psicología y Derecho, con herramientas especializadas para el desarrollo práctico de los estudiantes.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">La biblioteca del Campus se caracteriza por su estructura semicircular, la cual cuenta con acceso a libros físicos, bases de datos digitales y computadoras.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas. Además, tienen minisplits para aire caliente y frío, asegurando un ambiente cómodo en cualquier estación del año.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Fotos de instalaciones de campus Cancún"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Fotos de instalaciones de campus Cancún"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Canchas y zonas recreativas que promueven un estilo de vida saludable, integrando deporte y bienestar en la rutina estudiantil.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Es un espacio, donde se realizan eventos culturales, conferencias, encuentros multidisciplinarios, foros, debates y presentaciones.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en<br class="lg:block hidden"> Campus Magno Humanitas</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho'],
        Maestrías: ['Contabilidad'],
    }" class="flex items-center justify-center" />

    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/modelo-escolarizado-madin.webp" alt="Estudiante modelo escolarizado en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Cancún en nuestro tour virtual.</p>
            <Tour360 :src="'https://tourmkr.com/F11pV2GOlz'"  class="w-full mb-12"/>
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <Instalaciones :items="tour" class="" />
        </div>
    </div>
	<Ubicacion :campus="'Campus Magno Cancún'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3721.5431842860544!2d-86.846006!3d21.130771!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4c2bc15ccd36b9%3A0x73db0f03a9c3e64c!2sUniversidad%20Humanitas!5e0!3m2!1ses-419!2sus!4v1692813605957!5m2!1ses-419!2sus'" :testo1="'La principal vía de acceso es avenida Cancún, mientras que para llegar en transporte, se deben de considerar las rutas: R-11, R-26, R-44 y R-6.'" :ubicacion="'Av. Fonatur SM. 313 MZA., 18 LTE. 03, Esquina Almendros, Benito Juárez, Cancún C.P. 77560, Quintana Roo.'" :telefono="'998-802-1090'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
